import http from '../common/http';
import env from '../envConfig';
import { getHeader } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';

export const obterEnderecoFamilia = async (numeroFamiliar: number) => {
  const url = env.urlApi + `/transacional-api/v1/familia/${numeroFamiliar}/endereco`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterCaracteristicasDomicilio = async (numeroFamiliar: number) => {
  const url = env.urlApi + `/transacional-api/v1/familia/${numeroFamiliar}/caracteristicas-domicilio`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterInformacoesDetalhadasFamilia = async (numeroFamiliar: number) => {
  const url = env.urlApi + `/transacional-api/v1/familia/${numeroFamiliar}/informacoes-detalhadas`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterMembrosFamilia = async (numeroFamiliar: number) => {
  const url = env.urlApi + `/transacional-api/v1/familia/${numeroFamiliar}/membros`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterComprovanteCadastro = async (numeroFamiliar: number) => {
  const url = env.urlApi + `/transacional-api/v1/familia/${numeroFamiliar}/comprovante-cadastro`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterFamiliaPeloCPFIntegranteFamiliar = async (cpf: string) => {
  const url = env.urlApi + `/transacional-api/v1/familia/${cpf}/integrante`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const atualizarCadastroFamiliaV2 = async (familia: any) => {
  const url = env.urlApi + `/transacional-api/v1/familia/${familia.numeroFamiliarCaixa}/atualizarCadastro`;
  const headers = getHeader();
  const response = await http.post(url, familia.contatos, { headers });
  return responseHandler(response);
};

export const obterNumeroFamiliarPorCPFIntegrante = async (cpf: string) => {
  const url = env.urlApi + `/transacional-api/v1/familia/obterNumeroFamiliar/${cpf}/integrante`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const verificarPossiblidadeRemocaoFamiliaCadUnico = async (cpf: string, numeroFamiliar: string) => {
  const url = env.urlApi + `/transacional-api/v1/familia/${cpf}/permite-excluir-familia/${numeroFamiliar}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterDadosGeraisFamiliaAptaExcusaoPeloCPFIntegranteFamiliar = async (cpf: string, numeroFamiliar: string) => {
  const url = env.urlApi + `/transacional-api/v1/familia/${cpf}/integrante/dados-gerais-exclusao/${numeroFamiliar}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const excluirCadastroFamilia = async (cpf: string, numeroFamiliar: string) => {
  const url = env.urlApi + `/transacional-api/v1/familia/${cpf}/exclusao-familia-cadastro-unico/${numeroFamiliar}`;
  const headers = getHeader();
  const response = await http.delete(url, { headers });
  return responseHandler(response);
};

export const obterPendenciasOcorrenciasFamilia = async (idPessoa: number, numeroFamiliar: number) => {
  const url = env.urlApi + `/transacional-api/v1/familia/${idPessoa}/pendencias-ocorrencias/${numeroFamiliar}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterPendenciasOcorrenciasFamiliaRL = async (idRL: number, numeroFamiliar: number) => {
  const url = env.urlApi + `/transacional-api/v1/familia/${idRL}/pendencias-ocorrencias-rl/${numeroFamiliar}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const excluirIntegrantesPorObito = async (dados: any) => {
  let url = env.urlApi + `/transacional-api/v1/familia/exclusao-membros-obito-cadastro-unico/${dados.numeroFamiliar}?`;

  url += `nomeSolicitante=${dados.nomeSolicitante}&`;
  url += `listaPessoas=${dados.listaPessoas.join(',')}`;

  const headers = getHeader();
  const response = await http.delete(url, { headers });
  return responseHandler(response);
};
